import { Component, OnInit } from '@angular/core';
import { CategoriaService } from '../../../services/categoria/categoria.service';

@Component({
  selector: 'app-ficha-tecnica',
  templateUrl: './ficha-tecnica.component.html'
})
export class FichaTecnicaComponent implements OnInit {

  categorias: any[] = [];

  constructor(
    private _categoriaService: CategoriaService
  ) { }

  ngOnInit() {
    this._categoriaService.getPadresEHijas()
      .subscribe(
        (data) => {
          this.categorias = data;
        }
      );
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/shared/ficha-tecnica/ficha-tecnica.component.ts